import { Injectable } from '@angular/core';
import { UserSystemPreference } from '../models/userSystemPreference';
import { UserDetails } from '../models/userDetails';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  constructor() {}

  private _bussinessArea: any;
  public get getBussinessArea(): any {
    return this._bussinessArea == undefined ? null : this._bussinessArea;
  }
  public set setBussinessArea(value: any) {
    this._bussinessArea = value;
  }

  private _workFlowId: number = 0;
  public get getWFSelectedWorkFlowId(): number {
    const value = localStorage.getItem('_workFlowId');
    return value !== null ? +value : this._workFlowId;
  }
  public set setWFSelectedWorkFlowId(value: number) {
    this._workFlowId = value;
    localStorage.setItem('_workFlowId', value.toString());
  }

  private _wFQueueId: number = 0;
  public get getWFSelectedQueueId(): any {
    const value = localStorage.getItem('_wFQueueId');
    return value !== null ? +value : this._wFQueueId;
  }
  public set setWFSelectedQueueId(value: number) {
    this._wFQueueId = value;
    localStorage.setItem('_wFQueueId', value.toString());
  }

  private _fieldOrder: any;
  public get fieldOrder(): any {
    return this._fieldOrder == undefined ? null : this._fieldOrder;
  }
  public set fieldOrder(value: any) {
    this._fieldOrder = value;
  }

  private _userDetails: UserDetails | undefined;
  public get getUserDetails(): any {
    const stored = localStorage.getItem('UserDetails');
    this._userDetails = stored ? (JSON.parse(stored) as UserDetails) : undefined;
    return this._userDetails == undefined ? null : this._userDetails;
  }
  public set setUserDetails(value: UserDetails) {
    this._userDetails = value;
    localStorage.setItem('UserDetails', JSON.stringify(value));
  }

  private _selectedSystemId: string = '';
  public get getSelectedSystemId(): string {
    if (!this._selectedSystemId) {
      const storedId = localStorage.getItem('_selectedSystemId');
      return storedId ? storedId : '';
    }
    return this._selectedSystemId;
  }
  public set setSelectedSystemId(value: string) {
    this._selectedSystemId = value.toString();
    localStorage.setItem('_selectedSystemId', this._selectedSystemId);
  }

  private _userGPID: string = '';
  public get getUserGPID(): string {
    if (!this._userGPID) {
      const userGPId = localStorage.getItem('userGPID');
      return userGPId ? userGPId : '';
    }
    return this._userGPID;
  }
  public set setUserGPID(value: any) {
    this._userGPID = value;
    localStorage.setItem('userGPID', value);
  }

  private _selectedVendorCode: any;
  public get getSelectedVendorCode(): any {
    return this._selectedVendorCode == undefined ? null : this._selectedVendorCode;
  }
  public set setSelectedVendorCode(value: any) {
    this._selectedVendorCode = value;
  }

  private _userInfo: any;
  public get getUserInfo(): any {
    return this._userInfo == undefined ? null : this._userInfo;
  }
  public set setUserInfo(value: any) {
    this._userInfo = value;
  }

  private _userEmail: any;
  public get getUserEmail(): any {
    return this._userEmail == undefined ? null : this._userEmail;
  }
  public set setUserEmail(value: any) {
    this._userEmail = value;
  }

  private _userName: any;
  public get getUserName(): any {
    return this._userName == undefined ? null : this._userName;
  }
  public set setUserName(value: any) {
    this._userName = value;
  }

  private _userMarket: any;
  public get getUserMarket(): any {
    return this._userMarket == undefined ? null : this._userMarket;
  }
  public set setUserMarket(value: any) {
    this._userMarket = value;
  }

  private _userVendorCode: any;
  public get getUserVendorCode(): any {
    return this._userVendorCode == undefined ? null : this._userVendorCode;
  }
  public set setUserVendorCode(value: any) {
    this._userVendorCode = value;
  }

  private _userVendorName: any;
  public get getUserVendorName(): any {
    return this._userVendorName == undefined ? null : this._userVendorName;
  }
  public set setUserVendorName(value: any) {
    this._userVendorName = value;
  }

  private _userVendorRole: any;
  public get getUserVendorRole(): any {
    return this._userVendorRole == undefined ? null : this._userVendorRole;
  }
  public set setUserVendorRole(value: any) {
    this._userVendorRole = value;
  }

  private _userVendorcode: any;
  public get getUserVendorcode(): any {
    return this._userVendorcode == undefined ? null : this._userVendorcode;
  }
  public set setUserVendorcode(value: any) {
    this._userVendorcode = value;
  }

  private _userVendorUserId: any;
  public get getUserVendorUserId(): any {
    return this._userVendorUserId == undefined ? null : this._userVendorUserId;
  }
  public set setUserVendorUserId(value: any) {
    this._userVendorUserId = value;
  }

  private _userPreferredUsername: any;
  public get getUserPreferredUsername(): any {
    return this._userPreferredUsername == undefined ? null : this._userPreferredUsername;
  }
  public set setUserPreferredUsername(value: any) {
    this._userPreferredUsername = value;
  }

  private _userPerferenceRoutingButton: any;
  public get getUserPerferenceRoutingButton(): any {
    return this._userPerferenceRoutingButton == undefined ? null : this._userPerferenceRoutingButton;
  }
  public set setUserPerferenceRoutingButton(value: any) {
    this._userPerferenceRoutingButton = value;
  }
  
  private _userPreferences: UserSystemPreference[] = [];
  public get getUserPreferences(): UserSystemPreference[] {
    if (this._userPreferences.length === 0) {
      const stored = localStorage.getItem('_userPreferences');
      if (stored) {
        try {
          this._userPreferences = JSON.parse(stored);
        } catch (e) {
          console.error('Failed to parse user preferences:', e);
          this._userPreferences = [];
        }
      }
    }
    return this._userPreferences;
  }
  public set setUserPreferences(value: UserSystemPreference[]) {
    this._userPreferences = value;
    localStorage.setItem('_userPreferences', JSON.stringify(value));
  }

  private _isFullAccess: boolean = true;
  public get getIsFullAccess(): boolean {
    this._isFullAccess = localStorage.getItem('_isFullAccess') === 'true';
    return this._isFullAccess;
  }
  public set setIsFullAccess(value: boolean) {
    this._isFullAccess = value;
    localStorage.setItem('_isFullAccess', String(this._isFullAccess));
  }

  private _isPaymentCodeVisible: boolean = false;
  public get getIsPaymentCodeVisible(): boolean {
    this._isPaymentCodeVisible = localStorage.getItem('_isPaymentCodeVisible') === 'true';
    return this._isPaymentCodeVisible;
  }
  public set setIsPaymentCodeVisible(value: boolean) {
    this._isPaymentCodeVisible = value;
    localStorage.setItem('_isPaymentCodeVisible',String(this._isPaymentCodeVisible));
  }

  private _isVendorClassificationAccess: boolean = false;
  public get getIsVendorClassificationAccess(): boolean {
    this._isVendorClassificationAccess = localStorage.getItem('_isVendorClassificationAccess') === 'true';
    return this._isVendorClassificationAccess;
  }
  public set setIsVendorClassificationAccess(value: boolean) {
    this._isVendorClassificationAccess = value;
    localStorage.setItem('_isVendorClassificationAccess',String(this._isVendorClassificationAccess));
  }

  private _isRestrictedVendorClassificationAccess: boolean = false;
  public get getIsRestrictedVendorClassificationAccess(): boolean {
    this._isRestrictedVendorClassificationAccess = localStorage.getItem('_isRestrictedVendorClassificationAccess') === 'true';
    return this._isRestrictedVendorClassificationAccess;
  }
  public set setIsRestrictedVendorClassificationAccess(value: boolean) {
    this._isRestrictedVendorClassificationAccess = value;
    localStorage.setItem('_isRestrictedVendorClassificationAccess', String(this._isRestrictedVendorClassificationAccess));
  }

  private _isRestrictedVCPCAccess: boolean = false;
  public get getIsRestrictedVCPCAccess(): boolean {
    this._isRestrictedVCPCAccess = localStorage.getItem('_isRestrictedVCPCAccess') === 'true';
    return this._isRestrictedVCPCAccess;
  }
  public set setIsRestrictedVCPCAccess(value: boolean) {
    this._isRestrictedVCPCAccess = value;
    localStorage.setItem('_isRestrictedVCPCAccess', String(this._isRestrictedVCPCAccess));
  }

  private _isRestrictedPaymentCodeAccess : boolean = false;
  public get getIsRestrictedPaymentCodeAccess(): boolean {
    this._isRestrictedPaymentCodeAccess = localStorage.getItem('_isRestrictedPaymentCodeAccess') === 'true';
    return this._isRestrictedPaymentCodeAccess;
  }
  public set setIsRestrictedPaymentCodeAccess(value: boolean) {
    this._isRestrictedPaymentCodeAccess = value;
    localStorage.setItem('_isRestrictedPaymentCodeAccess', String(this._isRestrictedPaymentCodeAccess));
  }

  private _isApprover: boolean = false;
  public get getIsApprover(): boolean {
    this._isApprover = localStorage.getItem('_isApprover') === 'true';
    return this._isApprover;
  }
  public set setIsApprover(value: boolean) {
    this._isApprover = value;
    localStorage.setItem('_isApprover', String(this._isApprover));
  }

  private _isReadOnly: boolean = false;
  public get getIsReadOnly(): boolean {
    this._isReadOnly = localStorage.getItem('_isReadOnly') === 'true';
    return this._isReadOnly;
  }
  public set setIsReadOnly(value: boolean) {
    this._isReadOnly = value;
    localStorage.setItem('_isReadOnly', String(this._isReadOnly));
  }

  private _isFreight: boolean = false;
  public get getIsFreight(): boolean {
    this._isFreight = localStorage.getItem('_isFreight') === 'true';
    return this._isFreight;
  }
  public set setIsFreight(value: boolean) {
    this._isFreight = value;
    localStorage.setItem('_isFreight', String(this._isFreight));
  }

  private _AdvanceInititor: boolean = false;
  public get getAdvanceInititor(): boolean {
    this._AdvanceInititor = localStorage.getItem('_AdvanceInititor') === 'true';
    return this._AdvanceInititor;
  }
  public set setAdvanceInititor(value: boolean) {
    this._AdvanceInititor = value;
    localStorage.setItem('_AdvanceInititor', String(this._AdvanceInititor));
  }

  private _isANZUser: boolean = false;
  public get getIsANZUser(): boolean {
    this._isANZUser = localStorage.getItem('_isANZUser') === 'true';
    return this._isANZUser;
  }
  public set setIsANZUser(value: boolean) {
    this._isANZUser = value;
    localStorage.setItem('_isANZUser', String(this._isANZUser));
  }

  private _isChinaUser: boolean = false;
  public get getIsChinaUser(): boolean {
    this._isChinaUser = localStorage.getItem('_isChinaUser') === 'true';
    return this._isChinaUser;
  }
  public set setIsChinaUser(value: boolean) {
    this._isChinaUser = value;
    localStorage.setItem('_isChinaUser', String(this._isChinaUser));
  }

  private _isEGYSystem: boolean = false;
  public get getIsEGYSystem(): boolean {
    this._isEGYSystem = localStorage.getItem('_isEGYSystem') === 'true';
    return this._isEGYSystem;
  }
  public set setIsEGYSystem(value: boolean) {
    this._isEGYSystem = value;
    localStorage.setItem('_isEGYSystem', String(this._isEGYSystem));
  }

  private _isMeBev: boolean = false;
  public get getIsMeBev(): boolean {
    this._isMeBev = localStorage.getItem('_isMeBev') === 'true';
    return this._isMeBev;
  }
  public set setIsMeBev(value: boolean) {
    this._isMeBev = value;
    localStorage.setItem('_isMeBev', String(this._isMeBev));
  }

  private _isNonAdmin: boolean = false;
  public get getIsNonAdmin(): boolean {
    this._isNonAdmin = localStorage.getItem('_isNonAdmin') === 'true';
    return this._isNonAdmin;
  }
  public set setIsNonAdmin(value: boolean) {
    this._isNonAdmin = value;
    localStorage.setItem('_isNonAdmin', String(this._isNonAdmin));
  }

  private _isNonAdminWithRestrictedVCAccess: boolean = false;
  public get getIsNonAdminWithRestrictedVCAccess(): boolean {
    this._isNonAdminWithRestrictedVCAccess = localStorage.getItem('_isNonAdminWithRestrictedVCAccess') === 'true';
    return this._isNonAdminWithRestrictedVCAccess;
  }
  public set setIsNonAdminWithRestrictedVCAccess(value: boolean) {
    this._isNonAdminWithRestrictedVCAccess = value;
    localStorage.setItem('_isNonAdminWithRestrictedVCAccess', String(this._isNonAdminWithRestrictedVCAccess));
  }

  private _isWorkflowRetrievalApproverOnly: boolean = false;
  public get getIsWorkflowRetrievalApproverOnly(): boolean {
    this._isWorkflowRetrievalApproverOnly = localStorage.getItem('_isWorkflowRetrievalApproverOnly') === 'true';
    return this._isWorkflowRetrievalApproverOnly;
  }
  public set setIsWorkflowRetrievalApproverOnly(value: boolean) {
    this._isWorkflowRetrievalApproverOnly = value;
    localStorage.setItem('_isWorkflowRetrievalApproverOnly',String(this._isWorkflowRetrievalApproverOnly));
  }

  private _isWorkflowRetrievalVendorClassificationAccess: boolean = false;
  public get getIsWorkflowRetrievalVendorClassificationAccess(): boolean {
    this._isWorkflowRetrievalVendorClassificationAccess = localStorage.getItem('_isWorkflowRetrievalVendorClassificationAccess') === 'true';
    return this._isWorkflowRetrievalVendorClassificationAccess;
  }
  public set setIsWorkflowRetrievalVendorClassificationAccess(value: boolean) {
    this._isWorkflowRetrievalVendorClassificationAccess = value;
    localStorage.setItem('_isWorkflowRetrievalVendorClassificationAccess',String(this._isWorkflowRetrievalVendorClassificationAccess));
  }

  private _isWorkflowRetrievalAccess: boolean = false;
  public get getIsWorkflowRetrievalAccess(): boolean {
    this._isWorkflowRetrievalAccess = localStorage.getItem('_isWorkflowRetrievalAccess') === 'true';
    return this._isWorkflowRetrievalAccess;
  }
  public set setIsWorkflowRetrievalAccess(value: boolean) {
    this._isWorkflowRetrievalAccess = value;
    localStorage.setItem('_isWorkflowRetrievalAccess',String(this._isWorkflowRetrievalAccess));
  }

  private _isApproverVCSubAccess: boolean = false;
  public get getIsApproverVCSubAccess(): boolean {
    this._isApproverVCSubAccess = localStorage.getItem('_isApproverVCSubAccess') === 'true';
    return this._isApproverVCSubAccess;
  }
  public set setIsApproverVCSubAccess(value: boolean) {
    this._isApproverVCSubAccess = value;
    localStorage.setItem('_isApproverVCSubAccess',String(this._isApproverVCSubAccess));
  }

  private _isApproverSubstitutionAccess: boolean = false;
  public get getIsApproverSubstitutionAccess(): boolean {
    this._isApproverSubstitutionAccess = localStorage.getItem('_isApproverSubstitutionAccess') === 'true';
    return this._isApproverSubstitutionAccess;
  }
  public set setIsApproverSubstitutionAccess(value: boolean) {
    this._isApproverSubstitutionAccess = value;
    localStorage.setItem('_isApproverSubstitutionAccess',String(this._isApproverSubstitutionAccess));
  }

  private _isWorkflowApproverVCSubAccess: boolean = false;
  public get getIsWorkflowApproverVCSubAccess(): boolean {
    this._isWorkflowApproverVCSubAccess = localStorage.getItem('_isWorkflowApproverVCSubAccess') === 'true';
    return this._isWorkflowApproverVCSubAccess;
  }
  public set setIsWorkflowApproverVCSubAccess(value: boolean) {
    this._isWorkflowApproverVCSubAccess = value;
    localStorage.setItem('_isWorkflowApproverVCSubAccess',String(this._isWorkflowApproverVCSubAccess));
  }

  private _isMEFUser: boolean = false;
  public get getIsMEFUser(): boolean {
    this._isMEFUser = localStorage.getItem('_isMEFUser') === 'true';
    return this._isMEFUser;
  }
  public set setIsMEFUser(value: boolean) {
    this._isMEFUser = value;
    localStorage.setItem('_isMEFUser', String(this._isMEFUser));
  }

  private _isMyWorkBasketVisible: boolean = false;
  public get getIsMyWorkBasketVisible(): boolean {
    this._isMyWorkBasketVisible = localStorage.getItem('_isMyWorkBasketVisible') === 'true';
    return this._isMyWorkBasketVisible;
  }
  public set setIsMyWorkBasketVisible(value: boolean) {
    this._isMyWorkBasketVisible = value;
    localStorage.setItem('_isMyWorkBasketVisible',String(this._isMyWorkBasketVisible));
  }

  private _isWorkflowVisible: boolean = false;
  public get getIsWorkflowVisible(): boolean {
    this._isWorkflowVisible = localStorage.getItem('_isWorkflowVisible') === 'true';
    return this._isWorkflowVisible;
  }
  public set setIsWorkflowVisible(value: boolean) {
    this._isWorkflowVisible = value;
    localStorage.setItem('_isWorkflowVisible', String(this._isWorkflowVisible));
  }

  private _isRetrievalVisible: boolean = false;
  public get getIsRetrievalVisible(): boolean {
    this._isRetrievalVisible = localStorage.getItem('_isRetrievalVisible') === 'true';
    return this._isRetrievalVisible;
  }
  public set setIsRetrievalVisible(value: boolean) {
    this._isRetrievalVisible = value;
    localStorage.setItem('_isRetrievalVisible',String(this._isRetrievalVisible));
  }

  private _isWebuploadVisible: boolean = false;
  public get getIsWebuploadVisible(): boolean {
    this._isWebuploadVisible = localStorage.getItem('_isWebuploadVisible') === 'true';
    return this._isWebuploadVisible;
  }
  public set setIsWebuploadVisible(value: boolean) {
    this._isWebuploadVisible = value;
    localStorage.setItem('_isWebuploadVisible',String(this._isWebuploadVisible));
  }

  private _isVendorInfoVisible: boolean = false;
  public get getIsVendorInfoVisible(): boolean {
    this._isVendorInfoVisible = localStorage.getItem('_isVendorInfoVisible') === 'true';
    return this._isVendorInfoVisible;
  }
  public set setIsVendorInfoVisible(value: boolean) {
    this._isVendorInfoVisible = value;
    localStorage.setItem('_isVendorInfoVisible',String(this._isVendorInfoVisible));
  }

  public removeItem(value: string): void {
    if (!localStorage && !value) return;
    localStorage.removeItem(value);
  }
  public clearLocalStorage(): void {
    if (!localStorage) return;
    localStorage.clear();
  }

  public configureUserAccess(user: UserDetails): void {
    const { systemId, highestSecurityTypeName } = user;
    const securityType = highestSecurityTypeName?.toLowerCase() ?? '';
    console.log('Initializing user details with systemId:', systemId, 'and securityType:', securityType);

    // Region flags
    this.setIsMEFUser = systemId === 8006;
    this.setIsANZUser = systemId === 8003;
    this.setIsMeBev = systemId === 8007;
    this.setIsEGYSystem = systemId === 6000;
    this.setIsChinaUser = systemId === 8005;

    // Defaults
    this.setIsFullAccess = true;
    this.setIsApprover = false;
    this.setIsReadOnly = false;
    this.setAdvanceInititor = false;
    this.setIsNonAdmin = false;
    this.setIsVendorClassificationAccess = false;
    this.setIsPaymentCodeVisible = false;
    this.setIsRestrictedVendorClassificationAccess = false;
    this.setIsRestrictedVCPCAccess = false;
    this.setIsRestrictedPaymentCodeAccess = false;
    this.setIsWorkflowRetrievalApproverOnly = false;
    this.setIsWorkflowRetrievalVendorClassificationAccess = false;
    this.setIsWorkflowRetrievalAccess = false;
    this.setIsApproverVCSubAccess = false;
    this.setIsApproverSubstitutionAccess = false;
    this.setIsWorkflowApproverVCSubAccess = false;
    // Permission overrides
    switch (securityType) {
      case 'workitembasketonly':
      case 'editworkitembasketonly':
        this.setIsFullAccess = false;
        this.setIsApprover = true;
        break;
      case 'viewreadonly':
        this.setIsFullAccess = false;
        this.setIsReadOnly = true;
        break;
      case 'restrictedadminaccess':
        this.setIsFullAccess = false;
        this.setAdvanceInititor = true;
        break;
      case 'workflowretrievalmanagement':
        this.setIsFullAccess = false;
        this.setIsNonAdmin = true;
        break;
      case 'vendorclassificationonly':
        this.setIsFullAccess = false;
        this.setIsVendorClassificationAccess = true;
        break;
      case 'paymentcodeonly':
        this.setIsFullAccess = false;
        this.setIsPaymentCodeVisible = true;
        break;
      case 'restrictedvendorclassificationaccess':
        this.setIsFullAccess = false;
        this.setIsRestrictedVendorClassificationAccess = true;
        break;
      case 'restrictedvcpcaccess':
        this.setIsFullAccess = false;
        this.setIsRestrictedVCPCAccess = true;
        break;
      case 'restrictedpaymentcodeaccess':
        this.setIsFullAccess = false;
        this.setIsRestrictedPaymentCodeAccess = true;
        break;
      case 'workflowretrievalapproveronly':
        this.setIsFullAccess = false;
        this.setIsWorkflowRetrievalApproverOnly = true;
        break;
      case 'workflowretrievalvendorclassificationonly':
        this.setIsFullAccess = false;
        this.setIsWorkflowRetrievalVendorClassificationAccess = true;
        break;
      case 'approvervendorclassificationsubstitutionaccess':
        this.setIsFullAccess = false;
        this.setIsApproverVCSubAccess = true;
        break;
      case 'approversubstitutionaccess':
        this.setIsFullAccess = false;
        this.setIsApproverSubstitutionAccess = true;
        break;
      case 'workflowapprovervcsubstitutionaccess':
        this.setIsFullAccess = false;
        this.setIsWorkflowApproverVCSubAccess = true;
        break;
      case 'workflowretrievalonly':
        this.setIsFullAccess = false;
        this.setIsWorkflowRetrievalAccess = true;
        break;
      case 'nonadminwithrestrictedvcaccess':
        this.setIsFullAccess = false;
        this.setIsNonAdminWithRestrictedVCAccess = true;
        break;
    }
  }
}
